export default {
  EXTERIOR: 1,
  INTERIOR: 2,
  REPLACEMENT_COST: 3,
  SQUARE_FOOTAGE: 4,
  SUPPLEMENTAL_SINGLE: 5,
  SUPPLEMENTAL_MULTIPLE: 6,
};
